/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Statistic
 */
export interface Statistic {
  /**
   *
   * @type {string}
   * @memberof Statistic
   */
  statistic: string;
  /**
   *
   * @type {string}
   * @memberof Statistic
   */
  value: string;
}

/**
 * Check if a given object implements the Statistic interface.
 */
export function instanceOfStatistic(value: object): value is Statistic {
  if (!("statistic" in value) || value["statistic"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function StatisticFromJSON(json: any): Statistic {
  return StatisticFromJSONTyped(json, false);
}

export function StatisticFromJSONTyped(json: any, ignoreDiscriminator: boolean): Statistic {
  if (json == null) {
    return json;
  }
  return {
    statistic: json["statistic"],
    value: json["value"],
  };
}

export function StatisticToJSON(json: any): Statistic {
  return StatisticToJSONTyped(json, false);
}

export function StatisticToJSONTyped(
  value?: Statistic | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    statistic: value["statistic"],
    value: value["value"],
  };
}
